<div [class]="'notes notes--' + company | lowercase">
  <div class="notes__note" *ngFor="let note of notes">
    <span *ngIf="notationMarks">{{ notationMarks[note.code] }}</span>
    {{ note.text }}
  </div>
</div>
